// 客服：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 客服界面
export const ui = Object.freeze({
  "agentServiceUI.answerElapsed": "Total time {duration}",
  "agentServiceUI.answerSeconds": "{seconds}s",
  "agentServiceUI.answerMinutes": "{minutes}m {seconds}s",
  "agentServiceUI.copyAnswer": "Copy answer",
  "agentServiceUI.answerCopied": "Copied",
  "agentServiceUI.answerCopyFailed":
    "Copy failed. Select the text to copy it.",
  "agentServiceUI.supplyDemandCardExpand": "Expand listing details",
  "agentServiceUI.supplyDemandCardCollapse": "Collapse listing details",
  "agentServiceUI.supplyDemandCardToggleHint":
    "Double-click the card to expand or collapse listing details",
  "agentServiceUI.supplyDemandCardUnavailable":
    "Listing details are unavailable. Please reopen this listing.",
  "agentServiceUI.supplyDemandField.goodsType": "Chip type",
  "agentServiceUI.supplyDemandScene": "Supply and demand",
  "agentServiceUI.supplyDemandCardDetails": "View this listing snapshot",
  "agentServiceUI.supplyDemandSupply": "Supply",
  "agentServiceUI.supplyDemandDemand": "Demand",
  "agentServiceUI.supplyDemandField.infoNumber": "Information ID",
  "agentServiceUI.supplyDemandField.clueType": "Listing type",
  "agentServiceUI.supplyDemandField.partNumber": "Part number",
  "agentServiceUI.supplyDemandField.goodsName": "Product name",
  "agentServiceUI.supplyDemandField.goodsTitle": "Product title",
  "agentServiceUI.supplyDemandField.goodsBrand": "Brand",
  "agentServiceUI.supplyDemandField.goodsPrice": "Unit price",
  "agentServiceUI.supplyDemandField.goodsPriceUnit": "Currency",
  "agentServiceUI.supplyDemandField.goodsQuantity": "Quantity",
  "agentServiceUI.supplyDemandField.goodsUnit": "Quantity unit",
  "agentServiceUI.supplyDemandField.manufactureDate": "Batch",
  "agentServiceUI.supplyDemandField.usageScenario": "Condition",
  "agentServiceUI.supplyDemandField.deliveryAddress": "Source location",
  "agentServiceUI.supplyDemandField.goodsCategoryName": "Category",
  "agentServiceUI.supplyDemandField.categoryAttributes":
    "Category attributes",
  "agentServiceUI.supplyDemandField.goodsImage": "Image",
  "agentServiceUI.supplyDemandField.pictures": "Images",
  "agentServiceUI.supplyDemandField.specificationUrl": "Datasheet",
  "agentServiceUI.supplyDemandField.originCertificate":
    "Certificate of origin",
  "agentServiceUI.supplyDemandField.manufacturer": "Manufacturer",
  "agentServiceUI.supplyDemandField.weight": "Weight",
  "agentServiceUI.supplyDemandField.length": "Length",
  "agentServiceUI.supplyDemandField.width": "Width",
  "agentServiceUI.supplyDemandField.height": "Height",
  "agentServiceUI.supplyDemandField.goodsBuyMinQty":
    "Minimum order quantity",
  "agentServiceUI.supplyDemandField.substitutes": "Alternatives",
  "agentServiceUI.supplyDemandField.applications": "Applications",
  "agentServiceUI.supplyDemandField.goodsPeriod": "Validity",
  "agentServiceUI.supplyDemandField.deliveryPeriod": "Delivery days",
  "agentServiceUI.supplyDemandField.traderCompany": "Owner company",
  "agentServiceUI.supplyDemandField.remark": "Remarks",
  "agentServiceUI.supplyDemandField.productType": "Product type",
  "agentServiceUI.supplyDemandField.capacity": "Capacity",
  "agentServiceUI.supplyDemandField.architecture": "Architecture",
  "agentServiceUI.supplyDemandField.speed": "Speed",
  "agentServiceUI.supplyDemandField.ball": "Ball count",
  "agentServiceUI.moveGrip":
    "Move chat window by dragging or using arrow keys",
  "agentServiceUI.resizeHandle":
    "Resize chat window ({direction}) using arrow keys",
  "agentServiceUI.headerGrip":
    "Chat title bar; drag or use arrow keys to move the window",
  "agentServiceUI.online": "Online",
  "agentServiceUI.offline": "Offline",
  "agentServiceUI.closeChat": "Close chat",
  "agentServiceUI.dockLeft": "Dock chat to the left",
  "agentServiceUI.dockRight": "Dock chat to the right",
  "agentServiceUI.restoreChat":
    "Open customer support; drag or use arrow keys to move the floating button",
  "agentServiceUI.onlineSupport": "Customer support",
  "agentServiceUI.chatDialog": "Customer support chat",
  "agentServiceUI.messageInput": "Chat message",
  "agentServiceUI.sendMessage": "Send message",
  "agentServiceUI.send": "Send",
  "agentServiceUI.composerPlaceholder":
    "Type a message and press Enter to send",
  "agentServiceUI.handoffRequested": "Customer requested a human agent",
  "agentServiceUI.handoffHint":
    "Accept to reply directly; reject to return to the AI agent.",
  "agentServiceUI.rejectHandoff": "Decline handoff",
  "agentServiceUI.acceptHandoff": "Take over chat",
  "agentServiceUI.generalTitle": "XSOU Support",
  "agentServiceUI.generalDialog": "General customer support",
  "agentServiceUI.connectingSupport": "Connecting to support",
  "agentServiceUI.reload": "Reload",
  "agentServiceUI.generalEmpty":
    "Purchasing inquiries, platform help, after-sales support and company verification",
  "agentServiceUI.connecting": "Connecting",
  "agentServiceUI.loginRequired": "Please log in to use customer support.",
  "agentServiceUI.loginIdentityMissing":
    "Could not confirm your account. Please log in again to use customer support.",
  "agentServiceUI.realtimePolling":
    "Live connection is unavailable. Checking for new messages periodically.",
  "agentServiceUI.requestFailed":
    "Customer support request failed. Please try again.",
  "agentServiceUI.orderDialog": "Order support",
  "agentServiceUI.creatingConversation":
    "Setting up your support conversation",
  "agentServiceUI.orderScene": "Order {orderNum}",
  "agentServiceUI.waitingForStaff":
    "Waiting for a staff member to take over",
  "agentServiceUI.cannotSend": "Messages cannot be sent right now",
  "agentServiceUI.loadFailed": "Could not load the support conversation",
  "agentServiceUI.realtimeUnavailable":
    "Live connection is unavailable. You can still send and receive messages.",
  "agentServiceUI.recoveryReadFailed":
    "Could not retrieve messages after reconnecting",
  "agentServiceUI.sendFailed": "Message could not be sent",
  "agentServiceUI.retryFailed": "Message retry failed",
  "agentServiceUI.controlUpdateFailed":
    "Could not update the conversation status",
  "agentServiceUI.conversationLanguage": "Conversation language",
  "agentServiceUI.toggleTranslationMode":
    "Switch between single-language and bilingual views",
  "agentServiceUI.singleMode": "Single language",
  "agentServiceUI.bilingualMode": "Bilingual",
  "agentServiceUI.staffTranslationLanguage":
    "Staff translation: Simplified Chinese",
  "agentServiceUI.selectConversationLanguage":
    "Select conversation language",
  "agentServiceUI.customerLanguage": "Customer language",
  "agentServiceUI.customerLanguageWith": "Customer: {language}",
  "agentServiceUI.closeLanguageList": "Close language list",
  "agentServiceUI.conversationLanguageList": "Conversation language list",
  "agentServiceUI.retry": "Retry",
  "agentServiceUI.language": "Language",
  "agentServiceUI.returnToReadPosition":
    "Return to your last read position; {count} new messages",
  "agentServiceUI.newMessageCount": "{count} new messages",
  "agentServiceUI.loading": "Loading",
  "agentServiceUI.viewOlderMessages": "View older messages",
  "agentServiceUI.orderEmpty":
    "Ask about stock, lead time, MOQ or product details",
  "agentServiceUI.translating": "Translating…",
  "agentServiceUI.translationUnavailable": "Translation unavailable",
  "agentServiceUI.aiReply": "AI reply",
  "agentServiceUI.sending": "Sending",
  "agentServiceUI.sendFailedRetry": "Send failed. Click to retry",
  "agentServiceUI.aiResponding": "{name} is responding",
  "agentServiceUI.statusTemporarilyUnavailable":
    "Reply status is temporarily unavailable. Still waiting…",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "messageCenter.messagesFailed": "Unable to load messages",
  "messageCenter.sendFailed": "Unable to send. Please try again.",
  "messageCenter.searchContacts": "Search contacts",
  "messageCenter.loadingConversations": "Loading conversations...",
  "messageCenter.conversationsFailed": "Unable to load conversations",
  "messageCenter.noConversations": "No conversations",
  "messageCenter.loadingMessages": "Loading messages...",
  "messageCenter.noMessages": "No messages",
  "messageCenter.enterMessage": "Enter a message",
});

// PC界面显示文案；不改动业务原值。
export const desktopMessageCenter = Object.freeze({
  "messageCenter.search": "Search",
  "messageCenter.generalSupport": "General support",
  "messageCenter.orderSupport": "Order support",
  "messageCenter.aiEnabled": "enabled",
  "messageCenter.aiDisabled": "disabled",
  "messageCenter.aiAssistantLabel": "Chat assistant for {name}: {status}",
  "messageCenter.forgetLabel": "Forget Agent consultation memory for {name}",
  "messageCenter.deleteLabel": "Delete the entire conversation with {name}",
  "messageCenter.processing": "Processing",
  "messageCenter.forget": "Forget",
  "messageCenter.deleting": "Deleting",
  "messageCenter.delete": "Delete",
  "messageCenter.cancel": "Cancel",
  "messageCenter.image": "Image",
  "messageCenter.file": "File",
  "messageCenter.composerPlaceholder":
    "Type a message... (Enter to send, Shift+Enter for a new line)",
  "messageCenter.keyboardHint": "Enter to send, Shift+Enter for a new line",
  "messageCenter.chooseConversation":
    "Select a conversation on the left to start chatting",
  "messageCenter.unavailable": "Conversation unavailable",
  "messageCenter.forgetTitle": "Forget consultation memory",
  "messageCenter.forgetConfirm":
    "Only the Agent’s consultation memory will be deleted. Chat history will be kept, and the Agent will no longer refer to this consultation. Continue?",
  "messageCenter.confirmForget": "Confirm forget",
  "messageCenter.forgotten":
    "Consultation memory forgotten. Chat history has been kept.",
  "messageCenter.forgetFailed": "Unable to forget consultation memory",
  "messageCenter.deleteTitle": "Delete conversation",
  "messageCenter.deleteConfirm":
    "Delete the entire conversation with “{name}”? Chat history will be removed from both participants’ message centers. Existing consultation notes will become read-only history and will no longer be updated. To also clear the memory, use “Forget consultation memory” first.",
  "messageCenter.deleted": "Conversation deleted",
  "messageCenter.deleteFailed": "Unable to delete conversation",
  "messageCenter.authMissing":
    "Authorization parameters are missing. Please authorize again.",
  "messageCenter.wecomLoginFailed": "WeCom sign-in failed",
  "messageCenter.wecomLoginError": "Unable to sign in with WeCom",
  "messageCenter.unknownUser": "Unknown user",
  "messageCenter.syncFailed":
    "Unable to sync support messages. Please try again later.",
  "messageCenter.aiUpdateFailed": "Unable to update the AI assistant",
  "messageCenter.yesterday": "Yesterday {time}",
  "messageCenter.justNow": "Just now",
  "messageCenter.minutesAgo": "{count} min ago",
  "messageCenter.hoursAgo": "{count} hr ago",
  "messageCenter.operationFailed": "Support operation failed",
  "messageCenter.conversationMissing":
    "This conversation no longer exists. Please reopen support.",
  "messageCenter.conversationNotReady":
    "The support conversation has not been established yet",
  "messageCenter.sendingBusy": "A message is being sent. Please wait.",
  "messageCenter.controlBusy":
    "Support controls are being updated. Please wait.",
  "messageCenter.emptyMessage": "The message cannot be empty",
  "messageCenter.cannotSend":
    "Messages cannot be sent in the current conversation state",
  "messageCenter.controlUpdateFailed": "Unable to update support controls",
  "messageCenter.networkBusy": "The network is busy. Please try again later.",
});

export const messages = Object.freeze({
  ...desktopMessageCenter,
  ...mobileWorkflow,
  ...ui,
});
